<router-outlet></router-outlet>
<p-toast></p-toast>
<div class="spinner" *ngIf="loading$ | async" style="z-index: 11000; background-color: rgba(0, 0, 0, 0.4);">
  <p-progressSpinner *ngIf="loading$ | async" ></p-progressSpinner>
</div>
